import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectUserMasterInStore, selectUserMasterPageLoading, selectUserMasterShowInitWaitingMessage } from '../_selectors/userMaster.selectors';

export class UserMasterDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectUserMasterPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectUserMasterShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectUserMasterInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
